import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useEmailVerification(onSuccess: () => void) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const client = useApiClientUser()
  const verifyEmailMutation = useMutation({
    mutationFn: async (verifyToken: string) => {
      return await client.user
        .emailVerificationControllerVerifyEmail(
          { verifyToken },
          { secure: true }
        )
        .then(({ data }) => data)
    },
    onSuccess,
  })

  const resendEmailMutation = useMutation({
    mutationFn: async () => {
      return await client.user
        .emailVerificationControllerResendVerifyEmailToken({ secure: true })
        .then(({ data }) => data)
    },
  })

  return {
    isDialogOpen,
    handleOpenDialog: () => setIsDialogOpen(true),
    handleCloseDialog: () => setIsDialogOpen(false),

    verifyEmail: verifyEmailMutation.mutate,
    isRequestingVerifyEmail: verifyEmailMutation.isPending,
    verifyEmailError: getApiErrorMessage(
      verifyEmailMutation.error,
      'E-mail sa nepodarilo overiť.'
    ),

    resendEmail: resendEmailMutation.mutate,
    isRequestingResendEmail: resendEmailMutation.isPending,
    resendEmailError: getApiErrorMessage(
      resendEmailMutation.error,
      'Kód sa nepodarilo odoslať.'
    ),
  }
}

export { useEmailVerification }
